import React, {useEffect, useState} from "react";
import {getLastElementOr, isNotEmptyArray, showlog} from "../../utils";
import {deleteDatabaseById, downloadDatabaseById, loadDatabases} from "./databases-service";
import {orderFieldMap} from "../orders-page-v2/static";
import {OrderComponent} from "../orders-page-v2/components/OrderComponent";
import {prepareOrderCurl} from "../../business-logic/order";
import {dbFieldMap} from "./static";
import {downloadDB} from "./database";

export function DatabasesPage() {
	const [dbList, setDbList] = useState<any[]>([])

	useEffect(() => {
		getDatabasesList()
	}, [])

	async function getDatabasesList() {
		try {
			const dbs = await loadDatabases() || []
			showlog('dbs', dbs);
			setDbList(isNotEmptyArray(dbs?.list) ? dbs.list : []);
		} catch (e) {
			showlog("error in getDatabasesList()", e);
		}
	}

	async function handleDeleteDatabase(db: any) {
		const confirmed = window.confirm(`Sicuro di eliminare il database ${db?.name}?`);
		if (!confirmed) return;

		try {
			await deleteDatabaseById(db.id);
			await getDatabasesList();
		} catch (e) {
			showlog("error in handleDeleteDatabase()", e);
		}
	}

	return (
		<div className="databases-page">
			<h1>Databases</h1>
			<div
				className={'table-container'}
			>
				<table>
					<thead>
					<tr>
						{
							// tutti i campi
							Object.keys(dbList.reduce(getLastElementOr, []))

								// solo campi voluti
								.filter((dbField: string) => Object.keys(dbFieldMap).includes(dbField))

								// ordina i campi
								// .sort((a, b) => Object.keys(orderFieldMap).indexOf(a) - Object.keys(orderFieldMap).indexOf(b))

								// nome campi
								.map((dbField: string, dbFieldIndex: number): string => dbFieldMap[dbField])

								// campi in HTML
								.map((dbField: string, dbFieldIndex: number) => (

									<th
										onClick={(clickEvent: any) => {
											// TODO ordinamento
										}}
									>
										{dbField}
									</th>
								))

						}
						<th />
					</tr>
					</thead>
					<tbody>
					{
						dbList
							.map((db: any, dbIndex: number) => [db, undefined])
							.flatMap((db: any, dbIndex: number) => {
								// showlog('riga ordine ', db);
								return db;
							})
							.flatMap((db: any, dbIndex: number) => {
								showlog('db', db);

								return (
								<tr
									onClick={(clickEvent: any) => {
										if (!!db?.id) downloadDB(db.id, db.name)

									}}
									className={((dbIndex % 4) === 0) ? 'even-row' : 'odd-row'}
								>
									{
										!!db && (
											Object.keys(db)

												// solo campi voluti
												.filter((dbField: string, dbFieldIndex: number) => Object.keys(dbFieldMap).includes(dbField))

												// ordina i campi
												// .sort((a, b) => Object.keys(dbFieldMap).indexOf(a) - Object.keys(dbFieldMap).indexOf(b))

												// campi in HTML
												.map((dbField: string, dbFieldIndex: number) => {

													return (
														<td>{db[dbField]}</td>
													)
												})
										)
									}

									{
										!!db && (
											<td>
												<img
													src={'/imgs/delete.png'}
													className={'trash'}
													onClick={(clickEvent: any) => {
														clickEvent.stopPropagation();
														handleDeleteDatabase(db);
													}}
												/>
											</td>
										)
									}

								</tr>
							)})
					}
					</tbody>
				</table>
			</div>

		</div>
	);
}
